import React, { useEffect, useState } from 'react';
import LecturerSidebar from '../components/LecturerSidebar.js';
import '../styles/LecturerStudents.css';

export default function LecturerStudents() {
    const [students, setStudents] = useState([]);
    const [studentLoading, setStudentLoading] = useState(true);
    const [groups, setGroups] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState('');
    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => {
        async function fetchStudentList() {
            try {
                const token = localStorage.getItem('token');
                const response = await fetch(`${process.env.REACT_APP_API_URL}/lecturer/students/list`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
            
                if (response.ok) {
                    const data = await response.json();
                    setStudents(data);

                    // wyciągnięcie unikalnych nazw grup
                    const uniqueGroups = [...new Set(data.map(s => s.group_name))];
                    setGroups(uniqueGroups);
                } else {
                    console.error('Error fetching student list:', response.statusText);
                }
            } catch (error) {
                console.error('Error fetching student list:', error);
            } finally {
                setStudentLoading(false);
            }
        }
        fetchStudentList();
    }, []);

    // filtrowanie po grupie i wyszukiwaniu
    const filteredStudents = students.filter(student => {
        // Filtrowanie po grupie
        const matchesGroup = !selectedGroup || student.group_name === selectedGroup;
        
        // Filtrowanie po imieniu i nazwisku
        const matchesSearch = !searchQuery || 
            `${student.first_name} ${student.last_name}`.toLowerCase().includes(searchQuery.toLowerCase()) ||
            `${student.last_name} ${student.first_name}`.toLowerCase().includes(searchQuery.toLowerCase());
        
        return matchesGroup && matchesSearch;
    });

    return (
        <div className="lecture-dashboard-panel">
            <LecturerSidebar />
            <div className='main-content'>
                <div className='header'>
                    <h1 className='header-title'>Moi Kursanci</h1>
                </div>
                <div className='dashboard'>
                    <h2 className='page-title'>Moi Kursanci</h2>
                    <p className='page-subtitle'>Zarządzaj kursantami i ich danymi</p>

                    <div className='management-content'>
                        <div className='management-card'>
                            <div className='card-header-management'>
                                <div>
                                    <h3>Lista kursantów</h3>
                                </div>

                                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', flexWrap: 'wrap' }}>
                                    {/* 🔍 Wyszukiwanie po imieniu i nazwisku */}
                                    <div className='filter-container'>
                                        <label htmlFor="searchInput">Wyszukaj: </label>
                                        <input
                                            id="searchInput"
                                            type="text"
                                            placeholder="Imię lub nazwisko..."
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            style={{
                                                padding: '6px 10px',
                                                borderRadius: '6px',
                                                border: '1px solid #ccc',
                                                minWidth: '200px'
                                            }}
                                        />
                                    </div>

                                    {/* 🔽 Filtrowanie po grupie */}
                                    <div className='filter-container'>
                                        <label htmlFor="groupFilter">Filtruj po grupie: </label>
                                        <select
                                            id="groupFilter"
                                            value={selectedGroup}
                                            onChange={(e) => setSelectedGroup(e.target.value)}
                                        >
                                            <option value="">Wszystkie</option>
                                            {groups.map((group) => (
                                                <option key={group} value={group}>{group}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className='student-list-container'>
                                <div className='lecturer-student-grid-row student-list-header'>
                                    <span>Imię i Nazwisko</span>
                                    <span>Numer Indeksu</span>
                                    <span>Email</span>
                                    <span>Grupa</span>
                                </div>

                                {studentLoading && <p style={{textAlign: 'center'}}>Ładowanie kursantów...</p>}

                                {!studentLoading && filteredStudents.length === 0 && (
                                    <p style={{textAlign: 'center'}}>
                                        {searchQuery || selectedGroup 
                                            ? 'Brak kursantów spełniających kryteria wyszukiwania.' 
                                            : 'Brak kursantów w tej grupie.'}
                                    </p>
                                )}

                                {filteredStudents.map((student) => (
                                    <div key={student.student_id} className='lecturer-student-grid-row'>
                                        <span className='student-name'>{student.first_name} {student.last_name}</span>
                                        <span className='student-number'>{student.student_number}</span>
                                        <span className='student-email'>{student.email}</span>
                                        <span className='student-group'>{student.group_name}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
